import { base, createApiURL } from '../../../lib-api/services/base';
import { ajaxRetry } from '../../../lib-api/ajaxRetry';
import { IncomeCheckResponse } from '../models/incomeCheck';

export type CreateIncomeCheckPayload = {
  externalReference?: string;
  engineVersion?: string;
};

export const triggerCheck = ({ externalReference, engineVersion }: CreateIncomeCheckPayload) => {
  return ajaxRetry<IncomeCheckResponse>({
    data: JSON.stringify({ externalReference, engineVersion }),
    headers: base.headers(),
    method: 'POST',
    url: createApiURL(`/v2/income-checks`),
  });
};
